import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private http = inject(HttpClient);
  private apiUrl = '/api/users';

  joinOrganization(email: string, token: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/join`, { email, token });
  }

  verifyJoin(email: string, token: string, code: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/verify-join`, { email, token, code });
  }

  login(email: string, token: string, code: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/login`, { email, token, code });
  }

  getPendingUsers(orgId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/pending`, { params: { orgId } });
  }

  approveUser(adminEmail: string, userId: string, approve: boolean): Observable<any> {
    return this.http.post(`${this.apiUrl}/approve`, { adminEmail, userId, approve });
  }
}
